export const API = {
    // <------------ Development Url ---------->
    // BASE_URL:  'https://devapis.zupzap.com/v1/' ,
    
    // <------------ Production Url ------------->
    BASE_URL: 'https://apis.zupzap.com/v1/'
}